<template>
  <div class="animated fadeIn">
    <div class="container">
    </div>
  </div>
</template>

<script>

  export default {
    name: "Comparison"
  }

</script>
